import React from 'react';
export function Footer() {
  return <footer className="w-full py-8 px-4 bg-gray-900 text-gray-400 text-center" data-id="element-100">
      <p className="text-sm" data-id="element-101">
        © 2026 Huerta Express 30D — Todos los derechos reservados
      </p>
    </footer>;
}